import {
  alpha,
  type PaletteMode,
  type Theme,
  type ThemeOptions,
} from "@mui/material/styles";
import { buildMuiTheme, colors } from "@rubi/ui";

/**
 * Portal-only chrome over the shared theme. Palette slots, the report-status
 * channels and the shell's `frame` included, come from `palette` via
 * `buildMuiTheme` — only portal's component defaults live here, so the two
 * apps cannot drift apart again.
 */
const portalOverlay: ThemeOptions = {
  typography: {
    h6: {
      fontWeight: 400,
    },
  },
  components: {
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(colors.common.black, 0.04),
          "&$disabled": {
            backgroundColor: alpha(colors.common.black, 0.04),
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined" as const,
        margin: "dense" as const,
        size: "small" as const,
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: "outlined" as const,
        margin: "dense" as const,
        size: "small" as const,
      },
    },
  },
};

export const getTheme = (mode: PaletteMode): Theme =>
  buildMuiTheme(mode, portalOverlay);
